import { gql } from '@apollo/client';

export const MY_NOTIFICATION = gql`
  query myNotifications {
    myNotifications {
      recordId
      title
      description
      priority
      type
      read
      canDelete
      creationDate
      mission
      society
      link
    }
  }
`;

export const ME = gql`
  query me {
    me {
      profile {
        id
        provider
        roles
        displayName
        name {
          familyName
          givenName
        }
        email
      }
      bloomer {
        invitation {
          recordId
          token
          status
        }
        recordId
        fullname
        firstname
        lastname
        email
        slack
        secondaryEmail
        phoneNumber
        communicationType
        accountManager {
          fullname
          recordId
        }
        credentialID
        mission {
          isActive
          recordId
          label
          beginMission
          endMission
          CSM {
            fullname
          }
          clientSociety {
            name
            recordId
          }
          pricing {
            recordId
            purchasePricePerDayWithoutTaxes
            startDate
          }
          hoursPerDays
          bloomerBillingSociety {
            recordId
            name
            status
            siret
            KBIS
            KbisExpirationDate
            IBAN
            BIC
            URSSAFVigilanceCertificate
            URSSAFVCExpirationDate
            RCPVigilanceCertificate
            RCPExpirationDate
            portage
            addressCountryCode
            tva
            billingContact {
              recordId
              fullname
              firstname
              lastname
              email
              phoneNumber
              nameJob
            }
          }
        }
      }
    }
  }
`;
export const ALL_BLOOMERS = gql`
  query bloomers {
    bloomers {
      fullname
      recordId
      firstname
      lastname
      email
      phoneNumber
      slack
      accountManager {
        recordId
        fullname
      }
    }
  }
`;

// exemple d'usage de fragment grapqhl
const I_MISSIONS_PERIOD = gql`
  fragment IMissionPeriod on IMission {
    beginMission
    endMission
  }
`;

export const ALL_MISSIONS = gql`
  query allMissions($isActive: Boolean, $missionIds: [String]) {
    allMissions(isActive: $isActive, missionIds: $missionIds) {
      count
      results {
        recordId
        label
        bloomerFullName
        ...IMissionPeriod
        clientSocietyName
        bloomerSocietyName
        createdAt
        isActive
        replacement
        type
        hoursPerDays
        pricing {
          recordId
          startDate
          purchasePricePerDayWithoutTaxes
          salePricePerDayWithoutTaxes
          taxes
          astreinteCoef
        }
      }
    }
  }
  ${I_MISSIONS_PERIOD}
`;

export const ALL_MISSIONS_WITH_EXTENSION = gql`
  query allMissions($missionIds: [String]) {
    allMissions(missionIds: $missionIds) {
      count
      results {
        recordId
        label
        beginMission
        bloomerFullName
        endMission
        createdAt
        isActive
        clientSocietyName
        replacement
        hoursPerDays
        extension {
          assessment
          newEndDate
        }
        type
      }
    }
  }
`;

export const GET_ONE_ACTIVITY = gql`
  query activities($recordId: ID, $month: Date, $missionRecordId: String) {
    activities(recordId: $recordId, month: $month, missionRecordId: $missionRecordId) {
      recordId
      mission {
        recordId
        hoursPerDays
        beginMission
        endMission
      }
      month
      nbDaysWorked
      nbDaysMarkupWorked
      nbDaysMarkup2Worked
      nbDaysDetails
      astreinte
      billed
      validated
      signing
      signingDocumentId
      signedCount
      urlCraS3
      urlInvoicesS3
      signingEmbedBloomerId
      payed
      lastSupplierError
      supplierInvoiceStatus
      externalSupplierInvoiceId
      hoursPerDays
    }
  }
`;

export const ACTIVITIES_FOR_ONE_MISSION = gql`
  query missions($recordId: String) {
    missions(recordId: $recordId) {
      recordId
      label
      beginMission
      endMission
      enableCRAUpload
      enableBusinessReferalNpsBloomer
      contactOperations {
        recordId
        email
      }
      bloomerBillingSociety {
        recordId
        URSSAFVigilanceCertificate
        KBIS
        URSSAFVCExpirationDate
        RCPVigilanceCertificate
        RCPExpirationDate
        portage
        status
        addressCountryCode
        tva
      }
      activity {
        recordId
        month
        nbDaysWorked
        nbDaysMarkupWorked
        nbDaysMarkup2Worked
        nbDaysDetails
        astreinte
        billed
        validated
        signing
        signingDocumentId
        signedCount
        urlCraS3
        urlInvoicesS3
        urlAdditionalInvoicesS3
        signingEmbedBloomerId
        payed
        lastSupplierError
        supplierInvoiceStatus
        externalSupplierInvoiceId
        hoursPerDays
        CRAStatus
      }
      clientSocietyName
      hoursPerDays
      bloomerFullName
    }
  }
`;

export const MISSING_CRA = gql`
  query getMissingCRA($month: DateTime) {
    getMissingCRA(month: $month) {
      __typename
      ... on Mission {
        recordId
        bloomerFullName
        clientSocietyName
      }
      ... on Activity {
        bloomerFullname
        clientMission
        CRAStatus
        signingDocumentId
        mission {
          recordId
        }
      }
    }
  }
`;

export const ALL_AM = gql`
  query allAccountManagers {
    allAccountManagers {
      fullname
      recordId
    }
  }
`;

export const GET_ONE_FULL_MISSION = gql`
  query missions($recordId: String) {
    missions(recordId: $recordId) {
      origin
      hoursPerDays
      recordId
      jobId
      isActive
      replacement
      enableCRAUpload
      enableBusinessReferalNpsClient
      enableBusinessReferalNpsBloomer
      shouldBeCountAsDeal
      label
      beginMission
      endMission
      contractType
      clientPaydateDays
      bloomerPaydateDays
      billingContacts {
        fullname
        firstname
        lastname
        email
        phoneNumber
        recordId
        nameJob
      }
      type
      CSM {
        fullname
      }
      pricing {
        recordId
        taxes
        purchasePricePerDayWithoutTaxes
        salePricePerDayWithoutTaxes
        startDate
        astreinteCoef
      }
      bloomer {
        fullname
        recordId
        firstname
        lastname
        email
        secondaryEmail
        phoneNumber
        slack
        credentialID
        hiresweetContactId
        pipefyContactId
        accountManager {
          recordId
          fullname
        }
      }
      contactOperations {
        fullname
        firstname
        lastname
        email
        phoneNumber
        recordId
        nameJob
      }
      clientLegalContacts {
        fullname
        firstname
        lastname
        email
        phoneNumber
        recordId
        nameJob
      }
      bloomerLegalContacts {
        fullname
        firstname
        lastname
        email
        phoneNumber
        recordId
        nameJob
      }
      resolvedClientPdsContact {
        contact {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
        source
      }
      resolvedSupplierSstContact {
        contact {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
        source
      }
      clientSociety {
        name
        status
        siret
        recordId
        isClient
        billingContact {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
        legalContacts {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
      }
      clientBillingSociety {
        name
        status
        siret
        recordId
        addressCountryCode
        tva
        isClient
        billingContact {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
        legalContacts {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
      }
      bloomerBillingSociety {
        name
        status
        siret
        recordId
        portage
        KBIS
        KbisExpirationDate
        IBAN
        BIC
        URSSAFVigilanceCertificate
        URSSAFVCExpirationDate
        RCPVigilanceCertificate
        RCPExpirationDate
        addressCountryCode
        tva
        isClient
        billingContact {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
        legalContacts {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
      }
    }
  }
`;

export const GET_LEGAL_CONTACT_MISSION = gql`
  query legalContactMission($recordId: String) {
    missions(recordId: $recordId) {
      recordId
      resolvedClientPdsContact {
        contact {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
        source
      }
      resolvedSupplierSstContact {
        contact {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
        source
      }
    }
  }
`;

export const CHECK_INVITATION_TOKEN = gql`
  query checkInvitationToken($token: String!) {
    checkInvitationToken(token: $token) {
      recordId
      status
      mission
      emailCaptured
    }
  }
`;

export const GET_NOTIFICATION_CRA_HISTORY = gql`
  query getNotificationCraHistory($id: String, $month: Date, $missionId: String) {
    getNotificationCraHistory(id: $id, month: $month, missionId: $missionId) {
      processedOn
      id
      progress
      error
      data {
        recordId
        contact
        type
        title
      }
    }
  }
`;

export const RECRUITEMENTS = gql`
  query getRecruitements($isTrialPeriod: Boolean) {
    getRecruitements(isTrialPeriod: $isTrialPeriod) {
      customerName
      salesPriceWithoutTaxes
      trialPeriodEndDate
      billingDate
      description
      nextStep
      recordId
      billed
      externalId
      billingContactFullname
      replacement
      paymentTerms
      origin
      cancelled
      lastCustomerInvoiceError
      taxes
      externalCustomerInvoiceId
      externalCustomerInvoiceUrl
      bdc
      businessType
      invoiceStatus
      paymentTermsDetails
      bloomerRecord
      bloomer {
        recordId
        fullname
        firstname
        lastname
        email
      }
    }
  }
`;

export const BOOM = gql`
  query boom($code: Int) {
    boom(code: $code)
  }
`;

export const FINANCES = gql`
  query getFinances($beginDate: DateTime, $endDate: DateTime, $isExpense: Boolean) {
    getFinances(beginDate: $beginDate, endDate: $endDate, isExpense: $isExpense) {
      date
      price
      financeType
      year
      isExpense
      isForecast
    }
  }
`;

export const FINANCE_ONE_MONTH = gql`
  query getFinanceByMonth($date: DateTime, $isExpense: Boolean) {
    getFinanceByMonth(date: $date, isExpense: $isExpense) {
      date
      price
      financeType
      year
      isExpense
      isForecast
    }
  }
`;

export const MISSION = gql`
  query missions($activityMonth: DateTime, $isMissingCRA: Boolean, $recordId: String) {
    missions(recordId: $recordId, activityMonth: $activityMonth, isMissingCRA: $isMissingCRA) {
      bloomerFullName
      label
      clientSocietyName
      statusBloomer
      recordId
      bloomerPaydateDays
      beginMission
      endMission
      CSM {
        firstname
      }
      activity {
        bloomerFullname
        signingDocumentId
        month
        CRAStatus
        urlInvoicesS3
        urlAdditionalInvoicesS3
        recordId
        billed
        dateUploadInvoice
        clientMission
        validated
        lastError
        payed
        hoursPerDays
      }
    }
  }
`;

export const GET_MISSION_FOLLOWUP = gql`
  query getMissionFollowUp($month: String, $type: String, $activityId: String) {
    getMissionFollowUp(month: $month, type: $type, activityId: $activityId) {
      recordId
      score
      comment
      fullName
      missionLabel
      enableBusinessReferalNpsClient
    }
  }
`;

export const DASHBOARD_MISSION_DATA = gql`
  query dashboardMissionData($startDate: DateTime, $extended: Boolean) {
    dashboardMissionData(startDate: $startDate, extended: $extended) {
      D {
        currentYear {
          month
          count
          missionIds
        }
        lastYear {
          month
          count
          missionIds
        }
        diff {
          month
          count
        }
        average {
          currentYear
          lastYear
        }
      }
      NS {
        currentYear {
          month
          count
          missionIds
        }
        lastYear {
          month
          count
          missionIds
        }
        diff {
          month
          count
        }
        average {
          currentYear
          lastYear
        }
      }
      M {
        currentYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        lastYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        diff {
          month
          count
        }
        average {
          currentYear
          lastYear
        }
      }
      F {
        currentYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        lastYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        diff {
          month
          count
        }
        average {
          currentYear
          lastYear
        }
      }
      EB {
        currentYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        lastYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        diff {
          month
          count
        }
        average {
          currentYear
          lastYear
        }
      }
      BE {
        currentYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        lastYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        diff {
          month
          count
        }
        average {
          currentYear
          lastYear
        }
      }
      BR {
        currentYear {
          month
          count
          missionIds
        }
        lastYear {
          month
          count
          missionIds
        }
        diff {
          month
          count
        }
        average {
          currentYear
          lastYear
        }
      }
    }
  }
`;

export const GET_EXTENSION_ASSESSMENT = gql`
  query getExtensionAssessment($missionId: String!) {
    getExtensionAssessment(missionId: $missionId) {
      missionId
      assessment
      newEndDate
      updatedBy
      updatedAt
    }
  }
`;

const fieldForActivity = `{
  missionId
  missionLabel
  bloomerFullName
  clientSocietyName
  contactOperationsName
  activityId
  activityMonth
  status
  craURL
  invoiceURL
  signingDocumentId
  bloomerPayDateDays
  dateUploadInvoice
  bloomerInvoiceBilled
  bloomerInvoiceStatus
  bloomerInvoiceLastError
  supplierInvoiceStatus
  externalSupplierInvoiceId
  bloomerSocietyName
  bloomerSocietyPortage
  clientInvoiceStatus
  clientInvoiceLastError
  bloomerScore
  bloomerComment
  bloomerScoreDate
  clientScore
  clientComment
  clientScoreDate
  nbDaysWorked
  nbDaysMarkupWorked
  nbDaysMarkup2Worked
  nbDaysDetails
  nbDaysAstreinteWorked
  hoursPerDays
}`;

export const GET_CRA_BY_MONTH = gql`
  query getCraByMonth($month: DateTime) {
    getCraByMonth(month: $month) 
    ${fieldForActivity}
  }
`;

export const GET_CRA_BY_MISSION = gql`
  query getCraByMission($missionId: ID!) {
    getCraByMission(missionId: $missionId) 
    ${fieldForActivity}
  }
`;

export const GET_LEGAL_CONTRACTS_BY_MISSION = gql`
  query getLegalContractsByMission($missionId: String!) {
    getLegalContractsByMission(missionId: $missionId) {
      mission {
        id
        label
        bloomerId
        bloomerFullName
        clientSocietyId
        clientSocietyName
        bloomerSocietyName
      }
      contracts {
        id
        recordId
        createdAt
        createdDate
        signedDate
        type
        externalDocumentId
        nbSigner
        signedCount
        signerDocId1
        provider
        status
        contractTemplate
        step
        emptyFileUrl
        signedFileUrl
        refusedReason
        signLink
      }
    }
  }
`;

export const GET_LEGAL_CONTRACTS = gql`
  query getLegalContracts($status: MissionStatusFilter!) {
    getLegalContracts(status: $status) {
      mission {
        id
        label
        bloomerId
        bloomerFullName
        clientSocietyId
        clientSocietyName
        bloomerSocietyName
        accountManager {
          firstname
          lastname
        }
      }
      contracts {
        id
        recordId
        createdAt
        createdDate
        signedDate
        type
        externalDocumentId
        nbSigner
        signedCount
        signerDocId1
        provider
        status
        contractTemplate
        step
        emptyFileUrl
        signedFileUrl
        refusedReason
        signLink
      }
    }
  }
`;

export const CRM_VISITOR_TOKEN = gql`
  query getCRMVisitorToken {
    getCRMVisitorToken {
      token
      email
    }
  }
`;

export const GET_BLOOMIE_BY_EMAIL = gql`
  query getBloomieByEmail($email: String!) {
    getBloomieByEmail(email: $email) {
      firstname
      lastname
      email
      role
      avatarUrl
      phoneNumber
      externalId
    }
  }
`;

export const GET_CLIENT_ACTIVITY = gql`
  query getClientActivity($signingDocumentID: String!) {
    getClientActivity(signingDocumentID: $signingDocumentID) {
      recordId
      month
      nbDaysWorked
      nbDaysMarkupWorked
      nbDaysMarkup2Worked
      nbDaysDetails
      astreinte
      billed
      validated
      signing
      signingDocumentId
      signedCount
      urlCraS3
      signingEmbedBloomerId
      signingEmbedClientId
      payed
      lastSupplierError
      supplierInvoiceStatus
      externalSupplierInvoiceId
      hoursPerDays
      CRAStatus
      mission {
        recordId
        contactOperations {
          recordId
          email
        }
        clientSocietyName
        bloomerFullName
        label
      }
    }
  }
`;

export const GET_PUBLIC_CLIENT_ACTIVITY = gql`
  query getPublicClientActivity($signingDocumentID: String!) {
    getPublicClientActivity(signingDocumentID: $signingDocumentID) {
      recordId
      month
      nbDaysWorked
      nbDaysMarkupWorked
      nbDaysMarkup2Worked
      nbDaysDetails
      astreinte
      billed
      validated
      signing
      signingDocumentId
      signedCount
      urlCraS3
      signingEmbedBloomerId
      signingEmbedClientId
      payed
      lastSupplierError
      supplierInvoiceStatus
      externalSupplierInvoiceId
      hoursPerDays
      CRAStatus
      mission {
        recordId
        contactOperations {
          recordId
          email
        }
        clientSocietyName
        bloomerFullName
        label
      }
    }
  }
`;
